import { render } from "./PaginationBlock.vue?vue&type=template&id=d63ffdfc&scoped=true"
import script from "./PaginationBlock.vue?vue&type=script&lang=js"
export * from "./PaginationBlock.vue?vue&type=script&lang=js"

import "./PaginationBlock.vue?vue&type=style&index=0&id=d63ffdfc&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63ffdfc"]])

export default __exports__